import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button, InlineNotification } from '@carbon/react';
import { useAuthSession } from 'src/hooks/useAuthSession';
import { authClient } from 'src/services/auth/client';
import { clearAccessToken } from 'src/services/auth/tokenStore';

export const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { session, user } = useAuthSession();
  const navigate = useNavigate();
  const impersonatedBy = (session?.session as { impersonatedBy?: string | null } | undefined)?.impersonatedBy;

  if (!impersonatedBy) {
    return null;
  }

  return (
    <InlineNotification
      kind="warning"
      lowContrast
      hideCloseButton
      title={t('admin.impersonating', { email: user?.email })}
      actions={
        <Button
          kind="ghost"
          size="sm"
          onClick={async () => {
            await authClient.admin.stopImpersonating();
            clearAccessToken();
            navigate('/admin/users', { replace: true });
          }}
        >
          {t('admin.stopImpersonating')}
        </Button>
      }
    />
  );
};

export default ImpersonationBanner;
